// Define globally used constants here

export const LESSON_GROUP_TYPE: { [key: number]: string; } = {
    1: 'basic',
    2: 'extra',
    3: 'exam'
};